import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'trimleadingzero',
  standalone: true
})
export class TrimLeadingZero implements PipeTransform {
  transform(value: string) {
    return Utilities.trimLeadingZero(value);
  }
}
